import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {hashHistory} from "react-router";
import {withRouter} from "react-router-dom";
import {FormattedMessage} from "react-intl";
import sortBy from 'lodash/sortBy';

import {toggleUserPopup, changeStateToQuote} from "../actions/actionFunctions";
import {isIframe} from "../misc/helpers";
import ShoppingCartButton from "./ui/shoppingCartButton";
// import UserLoginButton from "./ui/userLoginButton";
import InstallButton from "./ui/installButton";
import HomeButton from "./ui/homeButton";
import WebsiteButton from './ui/websiteButton';
import Analytics from './../analytics';
import {UserPopupTypes} from "./visComponents/constants";
import ShareButton from "./common/shareButton";
import ShoppingCartListSwitcher from "./shoppingCart/shoppingCartListSwitcher";
import LanguageSwitcher from "./common/languageSwitcher";
import AdvancedQuotingSwitcher from "./shoppingCart/advancedQuoting/advancedQuotingSwitcher";
import CloneQuoteButton from "./popups/orderCompletePopup/cloneQuoteButton";
import HideItemsSwitcher from "./shoppingCart/hideItemsSwitcher";
import FabricatorCostSwitcher from "./shoppingCart/fabricatorCostSwitcher";
import {getFabricatorLogo} from "../misc/fabricatorHardcode";
import {IS_SUPER_ADMIN} from "../config";
import SuperAdminLoginButton from "./qkbPages/superAdmin/SuperAdminLoginButton";
import DevToolsPanel from "./common/devToolsPanel";
// import PrintButton from "./ui/printButton";

class DesktopHeader extends Component {

  static propTypes = {
    uploadsAndNotes: PropTypes.bool,
    hideTopButtons: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      subNavVisible: false,
    };
  }

  componentDidMount = () => {

  };

  handleUserLoginClick = (userPopupType = UserPopupTypes.Unlock) => {
    const fabricatorSettings = this.props.fabricatorData.settings;

    if (this.props.userIsLoggedIn) {
      if (fabricatorSettings.twoFA) {
        if (!this.props.isPhoneNumberValidated) {
          this.props.toggleUserPopup({
            userPopupOpened: true,
            userPopupType
          });
        } else {
          this.toggleMobileButton('userLogoutActive');
        }
      } else {
        this.toggleMobileButton('userLogoutActive');
      }
    } else {
      this.props.toggleUserPopup({
        userPopupOpened: true,
        userPopupType
      });
    }
  };

  toggleMobileButton = (activeFeature) => {
    this.setState({
      [activeFeature]: !this.state[activeFeature]
    })
  };

  toggleSubNav = () => {
    Analytics.sendClickEvent('toggle-sub-nav');
    this.setState({subNavVisible: !this.state.subNavVisible})
  };

  handleLogoClick = () => {
    Analytics.sendClickEvent('logo-click');
    if (window.location.hash !== "#/" && !window.location.href.includes("quote-design")) {
      hashHistory.push('/quote-design');
    }
  };

  render() {
    const fabricatorSettings = this.props.fabricatorData.settings;

    const allowInstallations = fabricatorSettings.addLaborCustomer
      || (document.kvConfig.isBackend && fabricatorSettings.addLaborInstaller);
    const showInstallations = allowInstallations && this.props.instList.length
      && (!this.props.showUnlockCalculations || (this.props.unlockCalculationsStep >= 2)) // tutorial
      && this.props.instList.some((instGroup) => instGroup.services.some(service => !service.autoAddWithProduct));

    const logoStyles = this.props.fabricatorData.logoUrl ? {} : {
      maxWidth: "500px",
    };

    const initialFlowIsRunning = document.kvConfig.initialFlowEnabled && this.props.initialFlowStep !== 3;
    const hideLogo = this.props.fabricatorData.received && this.props.fabricatorData.isLowes && isIframe();
    const isShoppingCartPage = this.props.location.pathname === "/shoppingcart";

    return (
      <div className="header-container">
        <DevToolsPanel/>
        <div className="selection-header">
          {!this.props.hideTopButtons && !this.props.isSQFTInVisualizer ? (
            <div className="selection-header__left">
              {this.props.uploadsAndNotes ? (
                <div className="shoppingcart-buttons">
                  <button className="shoppingcart-buttons__button ui-uploads">
                    <FormattedMessage id="header.uploads"/>
                  </button>
                  <button className="shoppingcart-buttons__button ui-notes">
                    <FormattedMessage id="header.notes"/>
                  </button>
                </div>
              ) : null}
              {this.props.fabricatorData.disableAdvanvedQuoting ? null : <AdvancedQuotingSwitcher/>}
              <HideItemsSwitcher/>
              <FabricatorCostSwitcher/>
              {/*<select name="" id="sls" onChange={(event) => {*/}
              {/*  this.props.checkIfNeedToSwitchRoom(null, event.target.value);*/}
              {/*}}>*/}
              {/*  <option value="Bathroom">Bathroom</option>*/}
              {/*  <option value="Kitchen">Kitchen</option>*/}
              {/*  <option value="Fireplace">Fireplace</option>*/}
              {/*</select>*/}
            </div>
          ) : null}
          {this.props.fabricatorData.received ? (
            <div className="selection-header__logo">
              {hideLogo ? null : <img src={getFabricatorLogo(this.props.fabricatorData)}
                                      style={logoStyles}
                                      alt="logo" onClick={this.handleLogoClick}/>}
            </div>
          ) : null}
          {this.props.fabricatorData.received && !this.props.hideTopButtons && !this.props.isSQFTInVisualizer ? (
            <div className="selection-header__right">
              {fabricatorSettings.enableSharing ? <ShareButton/> : null }
              <CloneQuoteButton/>
              <LanguageSwitcher/>
              {this.props.mobileNav && this.props.mobileNav.length
                ? <WebsiteButton onClick={this.toggleSubNav} />
                : initialFlowIsRunning
                  ? null
                  : <HomeButton />
              }
              {IS_SUPER_ADMIN ? <SuperAdminLoginButton/> : null}
              {/*{(fabricatorSettings.leadCaptureOnQuote && !initialFlowIsRunning && !(document.kvConfig.isBackend && document.kvConfig.jobId && document.kvConfig.canSaveQuote)) ? <UserLoginButton/> : null}*/}
              {fabricatorSettings.showPricing && !initialFlowIsRunning ? <ShoppingCartButton/> : null}
              {showInstallations && isShoppingCartPage && !initialFlowIsRunning ? <InstallButton questionShown={true}/> : null}
              {isShoppingCartPage && !initialFlowIsRunning ? <ShoppingCartListSwitcher/> : null}
            </div>
          ) : null}
        </div>
        <div className={"selection-header__sub" + (this.state.subNavVisible ? " selection-header__sub--opened" : "")}
             style={{height : this.state.subNavVisible ? this.props.mobileNav.length * 50 : 0}} >
          <ul className="selection-header__sub-nav">
            {this.renderSubNav(this.props.mobileNav)}
          </ul>
        </div>
      </div>
    )
  }

  renderSubNav = (nav) => {
    var _nav = sortBy(nav, n => n.displayOrder);
    return _nav.map(n => (
      <li className="selection-header__sub-nav--item" key={n.name + ":" + n.url + ":" + n.displayOrder}>
        <a className="bold" href={n.url} target="_blank" rel="noopener noreferrer">{n.name}</a>
      </li>
    ));
  }
}

const DesktopHeaderWithRouter = withRouter(props => <DesktopHeader {...props}/>);

const mapStateToProps = (store) => {
  const {selectionState, cartState, instState} = store;
  const {language} = store.serverState;
  const {isSQFTInVisualizer} = store.sqftState;

  return {
    selectionGroup: selectionState.selectionGroup,
    selectionFeatureInfo: selectionState.selectionFeatureInfo,
    selectionInfoQuantity: selectionState.selectionInfoQuantity,
    cartItems: cartState.cartItems,
    instList: instState.instList,
    mobileNav: store.navigationState.mobileNav,
    fabricatorData: store.fabricatorState,
    initialFlowStep: store.initialFlowState.initialFlowStep,
    showUnlockCalculations: store.unlockCalculationsState.showUnlockCalculations,
    unlockCalculationsStep: store.unlockCalculationsState.unlockCalculationsStep,
    language,
    isSQFTInVisualizer,
  };
};

export default connect(mapStateToProps, {
  toggleUserPopup,
  changeStateToQuote
})(DesktopHeaderWithRouter);
